var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons/faArrowRightFromBracket";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { loginApi } from "apis/eduidLogin";
import { EduIDButton } from "components/Common/EduIDButton";
import { useAppSelector } from "eduid-hooks";
import { eduidStore } from "eduid-init-app";
import { SIGNUP_BASE_PATH } from "helperFunctions/paths";
import { useCallback, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { useLocation, useNavigate } from "react-router";
import { HeaderNav } from "./HeaderNav";
export function Header({ loginRef }) {
    const dashboard_link = useAppSelector((state) => state.config.dashboard_link);
    const eduid_site_link = useAppSelector((state) => state.config.eduid_site_link);
    const login_url = useAppSelector((state) => state.config.login_service_url);
    const authn_options = useAppSelector((state) => state.login.authn_options);
    const eppn = useAppSelector((state) => state.personal_data.eppn);
    const [fetchLogout] = loginApi.useLazyFetchLogoutQuery();
    const location = useLocation();
    const navigate = useNavigate();
    const handleLogout = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        const response = yield fetchLogout({ ref: loginRef });
        if (response.isSuccess) {
            // Make sure to reset the store
            eduidStore.dispatch({ type: "RESET_STORE" });
            if (eduid_site_link) {
                sessionStorage.clear();
                globalThis.location.assign(eduid_site_link);
            }
        }
    }), [fetchLogout, loginRef, eduid_site_link]);
    const handleRegister = useCallback(() => {
        navigate(SIGNUP_BASE_PATH);
    }, [navigate]);
    const handleLogin = useCallback(() => {
        if (dashboard_link) {
            document.location.href = dashboard_link;
        }
    }, [dashboard_link]);
    const button = useMemo(() => {
        if (location.pathname.includes("register") ||
            location.pathname.includes("error") ||
            location.pathname.includes("errors") ||
            location.pathname.includes("reset-password")) {
            return (_jsx(EduIDButton, { buttonstyle: "secondary sm", id: "login", onClick: handleLogin, children: _jsx(FormattedMessage, { id: "common.logIn", defaultMessage: "Log in", description: "Header login" }) }));
        }
        else if (authn_options.has_session) {
            return (_jsxs(EduIDButton, { buttonstyle: "secondary icon sm", id: "logout", onClick: handleLogout, disabled: !login_url, children: [_jsx(FontAwesomeIcon, { icon: faArrowRightFromBracket }), _jsx(FormattedMessage, { id: "headerNav.logout", defaultMessage: "Log out", description: "Header logout" })] }));
        }
        else if (location.pathname.includes("login") && Object.keys(authn_options).length > 0) {
            return (_jsx(EduIDButton, { buttonstyle: "secondary sm", id: "register", onClick: handleRegister, children: _jsx(FormattedMessage, { id: "header.register", defaultMessage: "create eduid", description: "Header register" }) }));
        }
        else if (eppn) {
            return _jsx(HeaderNav, { handleLogout: handleLogout, login_url: login_url });
        }
    }, [authn_options, eppn, login_url, location.pathname, handleLogin, handleLogout, handleRegister]);
    return (_jsxs("header", { id: "header", children: [_jsx("a", { href: eppn ? dashboard_link : eduid_site_link, "aria-label": "eduID start", title: "eduID start", className: "eduid-logo", children: _jsx("div", { id: "eduid-logo" }) }), button] }));
}
